'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSignalCellularNoSim = function MdSignalCellularNoSim(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm6.1 6.5l29.1 29-2.2 2.2-3.1-3.2q-0.9 0.5-1.5 0.5h-16.8q-1.3 0-2.3-1t-0.9-2.4v-18.6l-4.4-4.4z m25.5 1.9v19.4l-18.9-18.9 3.9-3.9h11.8q1.3 0 2.3 1t0.9 2.4z' })
        )
    );
};

exports.default = MdSignalCellularNoSim;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/signal-cellular-no-sim.js
// module id = 3785
// module chunks = 168707334958949